import React, {useContext, useEffect, useState} from 'react';
import RegistrySearchHeader from './pageHeader/PageHeader';
import TableAdministration
    from '../../../components/tablesAdministration/Table-administration';
import {Deactivate} from '../../../components/modals/ModalUserDeactivate';
import {Show} from '../../../components/modals/ModalShow';
import {Edit} from '../../../components/modals/ModalEdit';
import {Add} from '../../../components/modals/ModalAdd';
import * as AXIOS from '../../../services/usersService';

import Swal from 'sweetalert2';
import {t,getLanguage} from 'react-switch-lang';

import './Users.scss';
import Loader from '../../../components/loader/Loader';
import {searchUsersTable} from "./searchUsersTable";

const Users = (props) => {


    const [items, setItems] = useState([]);
    const [filterItems, setFilterItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPage, setIsLoadingPage] = useState(true);
    const [modal, setModal] = useState(false);
    const [modalData, setModalData] = useState('');
    const [rowChanged, setRowChanged] = useState(false);
    const [search, setSearch] = useState('');
    const [tableKey, setTableKey] = useState(0);

    const fetchData = () => {
        
            setIsLoading(true);
            setIsLoadingPage(true);

            AXIOS.getAllUsers()
                .then((r) => {
                        setItems(generateRows(r.data));
                        setFilterItems(generateRows(r.data));
                        setIsLoading(false);
                        setIsLoadingPage(false);
                })
                .catch((r) => {
                    setIsLoading(false);
                    setIsLoadingPage(false);
                    if (r.message === 'Network Error') {
                        Swal.fire({
                            text: `${t('message.errorServerTitle')}`,
                            icon: 'error',
                            confirmButtonText: 'OK',
                        });
                    } else {
                        Swal.fire({
                            text: `${t('message.errorApi')}`,
                            icon: 'error',
                            confirmButtonText: 'Ok',
                        });
                    }
                });
        
    };
const getAuthority =(param, authorityArray)=>{
    const result = [];
    if(Array.isArray(authorityArray)){
        authorityArray.map(item=> {
            result.push(item[param])
        })
    }
    return result.length > 0 ? result.join(", ") : "";

}

    const generateRows = (items) => {
        return items.map(item => {
            let lang;
            if (item.langKey === 'mne') {
              if (getLanguage() === 'mne') {
                lang = t('language.mneLat')
              } else {
                lang = t('language.mneLat')
              }
            } else {
              if (getLanguage() === 'eng') {
                lang = t('language.english')
              } else {
                lang = t('language.english')
              }
            }
         
            return {
                username: item.login,
                firstName: item.firstName,
                lastName: item.lastName,
                email: item.email,
               authority: getLanguage()==='eng' ? getAuthority('name', item.authority) : getAuthority('description', item.authority),
                activated: item.activated,
                langKey: lang,
                onClick: () => onRowClick(item),
                buttons: [
                    
                        <Edit data={item} id="user"
                              setRowChanged={() => onRowChange()}/>
                    
                ,
                        <Deactivate
                            data={item}
                            id="user"
                            setRowChanged={() => onRowChange()}
                        />
                
                ],
            };
        }
        );
    }
    const filterList = (event) => {
        const search = event.target.value;
        setSearch(search);
        setFilterItems(searchUsersTable(search, items))

    };

    useEffect(() => {
            fetchData();
    }, [rowChanged]);

    const onRowClick = (item) => {
        setModalData(item);
        setModal(!modal + 1);
    };

    const onRowChange = () => {
        setRowChanged(!rowChanged);
        setSearch('')
        setTableKey(tableKey + 1);
    };

    const tableHeader = [
        t('users.label.username'),
        t('users.label.firstname'),
        t('users.label.lastname'),
        t('users.label.email'),
        t('users.label.authorities'),
        t('users.label.langKey'),
    ];

    return (
        <div style={{padding: "0 30px"}} className=" h-100  pb-3">
            
            <Show
                data={modalData}
                id="user"
                type='user'
                modal={modal}
                setModal={setModal}
                isEditable={true}
                setRowChanged={() => onRowChange()}
            />
            <RegistrySearchHeader
                placeholder={t('users.searchInput')}
                button={
                 
                    <Add id="user" setRowChanged={() => onRowChange()} />
                  
                }
               
                onChange={(e) => filterList(e)}
                showInput={true}
                showButton={true}
              
            />
           
                <div
                    className="position-relative administration-page-table-container pt-4">
                    {isLoadingPage && <Loader/>}

                    <TableAdministration
                        key={tableKey}
                        tableHeader={tableHeader}
                        tableRows={search ? filterItems : items}
                        hasMore={false}
                        isLoading={isLoading}
                        editableRow={false}
                    />
                </div>
            
        </div>
    );
};

export default Users;